import React from 'react';
import classNames from 'classnames/bind';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { useFixedTitle } from '@src/mobile/event/layout/Nav/hooks';
import { smoothScroll } from '@src/public/utils';
import { ListStore } from '../store';
import styles from './index.css';

const cx = classNames.bind(styles);

const Nav = () => {
    const listStore = ListStore.useContainer();
    const { listStates } = listStore;
    const { title } = listStates;

    const showBackToTop = useFixedTitle(0);

    return (
        <>
            <div className={`${styles.navBg} ${styles.navBgH5}`}>
                <div className={styles.title}>#{title}</div>
            </div>
            <div
                className={cx('backToTop', { backToTopShow: showBackToTop })}
                onClick={() => {
                    smoothScroll(window, 0);
                }}
            />
        </>
    );
};

export default errorBoundary(Nav);
